import { render } from "./MindtabFornitori.vue?vue&type=template&id=77fbe7fc&scoped=true"
import script from "./MindtabFornitori.vue?vue&type=script&lang=js"
export * from "./MindtabFornitori.vue?vue&type=script&lang=js"

import "./MindtabFornitori.vue?vue&type=style&index=0&id=77fbe7fc&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77fbe7fc"]])

export default __exports__